import type { ReactNode } from "react";

import { cx } from "@/lib/cx";

import "./ui.css";

type CardProps = {
  title?: ReactNode;
  subtitle?: ReactNode;
  /** Rechtsboven in de kaartkop: filter, knop, legenda-toggle. */
  actions?: ReactNode;
  /** Onderin, meestal de herkomstvoetnoot. */
  footer?: ReactNode;
  /** Laat de binnenmarge weg — voor een tabel die tot de rand loopt. */
  flush?: boolean;
  /** De inhoud vult de resthoogte van de kaart, bijvoorbeeld een kaartbeeld naast een kolom. */
  fill?: boolean;
  className?: string;
  children: ReactNode;
};

/** Het witte vlak op lichtgrijs waar elk scherm uit is opgebouwd. */
export function Card({ title, subtitle, actions, footer, flush, fill, className, children }: CardProps) {
  return (
    <section className={cx("atl-card", className)}>
      {(title || actions) && (
        <header className="atl-card__header">
          <div className="atl-card__titles">
            {title && <h2 className="atl-card__title">{title}</h2>}
            {subtitle && <p className="atl-card__subtitle">{subtitle}</p>}
          </div>
          {actions}
        </header>
      )}
      <div className={cx("atl-card__body", flush && "atl-card__body--flush", fill && "atl-card__body--fill")}>{children}</div>
      {footer && <footer className="atl-card__footer">{footer}</footer>}
    </section>
  );
}
